import { VERBS, XAPI_STATEMENT_TEMPLATES, getContentCategoryFromPath } from '../utils'

/**
 * @typedef {object} PageViewStatementPayload
 * @property {object} content - The content the user is interacting with.
 * @property {object} tenant - The tenant.
 */
/**
 * Create Prime statement.
 * @param {PageViewStatementPayload} payload
 */
const createPrimeStatement = (payload) => {
  const statement = buildStatement(payload)
  const { content } = payload

  if (
    content?.legacyContent?.source === 'prime' &&
    content?.legacyContent?.id
  ) {
    statement.activity.extensions.pageId = content.legacyContent.id
  }

  return statement
}

/**
 * Create Helix statement.
 * @param {PageViewStatementPayload} payload
 */
const createHelixStatement = (payload) => {
  const statement = buildStatement(payload)
  const { content } = payload

  if (
    content?.legacyContent?.source === 'helix' &&
    content?.legacyContent?.id
  ) {
    statement.activity.extensions.pageId = content.legacyContent.id
  }

  return statement
}

/**
 * Create an XAPI event payload.
 * @param {PageViewStatementPayload} payload - XAPI payload.
 */
const buildStatement = ({
  content,
  tenant
}) => {
  const { topicName, subjectName } = getContentCategoryFromPath(content.categoryPath)
  const [pageType] = content.primaryType

  return {
    verb: VERBS.PAGE_VIEW,
    activity: {
      extensions: {
        pageType,
        pageId: content.locationId,
        skillArea: subjectName,
        subSkillArea: topicName
      }
    }
  }
}

/**
 * Create an XAPI event payload.
 * @param {PageViewStatementPayload} payload - XAPI payload.
 * @returns {object}
 */
const create = (payload) => {
  const template =
    payload?.tenant?.features?.xapi?.statementTemplate ||
    XAPI_STATEMENT_TEMPLATES.MT3

  if (template === XAPI_STATEMENT_TEMPLATES.PRIME) {
    return createPrimeStatement(payload)
  }

  if (template === XAPI_STATEMENT_TEMPLATES.HELIX) {
    return createHelixStatement(payload)
  }

  return buildStatement(payload)
}

export default {
  create
}
